import { useEffect, RefObject } from 'react';

const config: IntersectionObserverInit = {
  rootMargin: '0px 0px 256px 0px',
  threshold: 0
};

const useOnIntersect = (node: RefObject<Element>, callback: () => void): void => {
  useEffect(() => {
    if (!node.current) return;

    const observer = new IntersectionObserver((entries, self) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback();
          self.unobserve(entry.target);
        }
      });
    }, config);

    observer.observe(node.current);

    return () => {
      observer.disconnect();
    };
  }, [node, callback]);
};

export default useOnIntersect;
